import React, { useEffect, useState } from 'react';
import { AppBar, Box, Dialog, DialogContent, IconButton, Slide, Toolbar, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ResultsReviewCard from '../../components/common/cards/ResultsReviewCard';
import { ResultSessionStorageKey, ResultTableParameterStorageService } from '../../services/sessionStorage';
import sizeConfigs from '../../configs/sizeConfigs';
import colorConfigs from '../../configs/colorConfigs';
import { TransitionProps } from '@mui/material/transitions';
import CloseIcon from '@mui/icons-material/Close';
import fontConfigs from '../../configs/fontConfigs';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BulkReviewPage: React.FC = () => {
  const navigate = useNavigate();
  const [resultIds, setResultIds] = useState<any[]>(() => {
    return ResultTableParameterStorageService.get(ResultSessionStorageKey.bulkReviewIds) || []
  });

  useEffect(() => {
    console.log('BulkReviewPage mounted', resultIds);
  }, [resultIds]);

  // Notify opener to refresh (ResultsPage listens for this)
  const notifyOpenerToRefresh = () => {
    try {
      localStorage.setItem('resultsNeedsRefresh', String(Date.now()));
    } catch {
      // no-op
    }
  };

  // Close this tab if script-opened, else fallback to /results
  const handleBackButton = () => {
    notifyOpenerToRefresh();
    if (window.opener) {
      window.close();
    } else {
      console.log('No window.opener - navigating to /results');
      navigate('/results', { replace: true, state: { fromBulkReview: true } });
    }
  };

  // onUpdated is called after save in ResultsReviewCard
  const handleUpdated = () => {
    notifyOpenerToRefresh();
  };

  if (!resultIds) return null;

  return (
    <Dialog
      open={true}
      fullScreen
      // onClose={() => { setResult(""); setPopup("") }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      TransitionComponent={Transition}
      sx={{
        height: '100vh',
        minHeight: '100vh',
        '& .MuiDialog-paper': {
          alignItems: 'center',
          justifyContent: 'center',
          p: 0,
          height: '100vh',
          minHeight: '100vh'
        },
      }}
    >
      <AppBar
        // onClick={handleBackButton}
        sx={{
          position: 'fixed',
          top: 0,
          height: sizeConfigs.detailPage.appbar.height,
          minHeight: sizeConfigs.detailPage.appbar.height,
          maxHeight: sizeConfigs.detailPage.appbar.height,
          zIndex: 1201,
        }}
      >
        <Toolbar
          sx={{
            height: sizeConfigs.detailPage.appbar.height,
            minHeight: sizeConfigs.detailPage.appbar.height,
            maxHeight: sizeConfigs.detailPage.appbar.height,
            padding: 0,
            backgroundColor: colorConfigs.tables.headBg,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#fff',
          }}
        >
          <Box onClick={(e) => e.stopPropagation()} sx={{ m: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'baseline' }}>
            <Typography sx={{ fontWeight: "bold", color: '#fff', ml: 2, fontSize: fontConfigs.detailPage.appbar.label, padding: "0 8px" }}>
              Review Results
            </Typography>
          </Box>
          {/* <IconButton
            edge="start"
            color="inherit"
            onClick={handleBackButton}
            aria-label="close"
            sx={{
              position: 'absolute',
              right: 8,
              padding: 0,
              fontSize: '18px',
            }}
          >
            <CloseIcon />
          </IconButton> */}
        </Toolbar>
      </AppBar>

      <DialogContent
        sx={{
          height: sizeConfigs.detailPage.dialogContent.height,
          minHeight: sizeConfigs.detailPage.dialogContent.height,
          overflowY: 'auto',
          '&::-webkit-scrollbar': { display: 'none' },
          msOverflowStyle: 'none', // Internet Explorer 10+
          scrollbarWidth: 'none', // Firefox
          p: 0,
          m: 0,
          minWidth: '100vw',
          backgroundColor: colorConfigs.sidebar.bg,
          mt: sizeConfigs.detailPage.appbar.height,
        }}
      >
        <ResultsReviewCard
          onUpdated={handleUpdated}
          handleBackButton={handleBackButton}
          resultIds={resultIds}
        />
      </DialogContent>
    </Dialog>
  )
};

export default BulkReviewPage;
